import { Injectable, inject, ViewChild } from '@angular/core';
import { Database, equalTo, listVal, objectVal, onValue, orderByChild, query, ref, remove } from '@angular/fire/database';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AcuerdoMrbService {
  private database: Database = inject(Database);
  private http = inject(HttpClient);

  public cats =  {
    CATEGORIZACION:'categorizacion', 
    ESTADO_ENTREGABLE: 'estado_entregable',
    ESTADO_TEMA: 'estado_tema',
    ROL_USUARIO: 'rol_usuario',
    TIPO_FORMA_ENVIO: 'tipo_forma_envio',
    TIPO_TEMA: 'tipo_tema',
  }

  getAcuerdos () {
    return this.http.post(environment.acuerdos.consultarAcuerdos+"/1/4", {});
  }

  getTemas (idAcuerdo: any, edicion: boolean = false) {
    return this.http.get(`${environment.acuerdos.detalleAcuerdoMR}/${idAcuerdo}/${edicion}`);
  }

  // OBTENER CATALOGOS ///////////////////////////////////////////
  getCatalogo (tipo_catalogo: string) {
    return this.http.get(environment.catalogos.getCatalogo + tipo_catalogo).pipe(
      map((data:any) => {
        if(data.error) return [{id:0, descripcion:'Error al cargar catalogo'}];
        if(tipo_catalogo == this.cats.TIPO_FORMA_ENVIO) return data.tipoEnvio;
        if(tipo_catalogo == this.cats.TIPO_TEMA) return data.tipoTema;
        if(tipo_catalogo == this.cats.CATEGORIZACION) return data.tiposCategorizacion;
        return data;
      })
    );
  }

  getCategoria () {
    return this.http.get(environment.acuerdos.categoria).pipe(
      map((data:any) => {
        if(data.error) return [{id:0, descripcion:'Error al cargar catalogo'}];
        return data.categoria;
      })
    );
  }

  agregarAcuerdo (oDataAcuerdo: any) {
    return this.http.post(environment.acuerdos.agregarAcuerdo, oDataAcuerdo);
  }

  agregarTema (oDataTema: any) {
    return this.http.post(environment.acuerdos.guardarTema, oDataTema);
  }

  getResponsablesAll () {
    return this.http.get(environment.catalogos.consultaResponsables).pipe(
      map((data:any) => {
        if(data.error) return [{id:0, descripcion:'Error al cargar catalogo'}];
        let catalogoUsuarios =  data.responsables.analista.concat(data.responsables.supervisor).concat(data.responsables.coordinador);
        catalogoUsuarios =  catalogoUsuarios.map((item:any) => { item.id = item.idFB; item.rol = item.idRol; item.activo = item.banEsActivo; return item; });
        return catalogoUsuarios;
      })
    );
  }

  notificar (oData: any) {
    const endpoint = `${environment.acuerdos.notificacion}/mrb/${oData.notificacion}`;
    return this.http.post(endpoint, oData);
  }
}
